import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  ExecuteGet<T>(url: string, urlParam?: string | null, queryParams?: HttpParams): Observable<T> {
    if (urlParam) {
      url = url + '/' + urlParam;
    }
    return this.http.get<T>(url, { params: queryParams });
  }

  ExecutePost<T>(url: string, body: any, urlParam?: string | null, queryParams?: HttpParams): Observable<T> {
    if (urlParam) {
      url = url + '/' + urlParam;
    }
    return this.http.post<T>(url, body, { params: queryParams });
  }

  ExecutePut<T>(url: string, body: any, urlParam?: string | null, queryParams?: HttpParams): Observable<T> {
    if (urlParam) {
      url = url + '/' + urlParam;
    }
    return this.http.put<T>(url, body, { params: queryParams });
  }

  ExecuteDelete<T>(url: string, urlParam?: string | null, queryParams?: HttpParams): Observable<T> {
    if (urlParam) {
      url = url + '/' + urlParam;
    }
    return this.http.delete<T>(url, { params: queryParams });
  }

}
